import { QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { ReactElement } from 'react';
import styled from 'styled-components';

import LandingPageHome from '../components/LandingPageHome';
import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';
import useRoutePrefetch from '../hooks/useRoutePrefetch';
import { detectAndBestEffortSetLanguage } from '../utils/localisationUtils';
import { dehydrateReactQueryPrefetchedInfiniteQuery } from '../utils/react-query-utils';

const Home: NextPageWithLayout = () => {
  useRoutePrefetch('/[tenantId]/lessons');
  useRoutePrefetch('/[tenantId]/workspace/[workspaceId]');

  return (
    <Container>
      <LandingPageLayout hideBlobs={true} disableHeadline={true}>
        <LandingPageHome />
      </LandingPageLayout>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
`;

export const getServerSideProps: GetServerSideProps = async context => {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=3600, stale-while-revalidate=1209600',
  );
  const queryClient = new QueryClient();

  return {
    props: {
      dehydratedState: dehydrateReactQueryPrefetchedInfiniteQuery(queryClient),
      ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'marketing' })),
    },
  };
};

Home.getLayout = function getLayout(page: ReactElement) {
  return <>{page}</>;
};
export default Home;
